<template>
  <v-content class="pa-0 ma-0">
    <v-data-table
      v-if="documents != null"
      :items="documents"
      :headers="headers"
      disable-initial-sort
      item-key="id"
    >
      <template slot="items" slot-scope="props">
        <tr :key="props.index">
          <td class="text-xs-left">
            <a
              class="black--text"
              style="cursor: pointer"
              @click="openDocument(props.item.loggable)"
              target="_self"
            >
              {{ props.item.loggable.name }}
            </a>
          </td>
          <td class="text-xs-left">
            <a
              class="black--text"
              style="cursor: pointer"
              @click="viewClient(props.item.company_id)"
              target="_self"
            >
              {{ getNameAndUserOfCompany(props.item.company_id) }}
            </a>
          </td>
          <td class="text-xs-left">
            <a
              class="black--text"
              style="cursor: pointer"
              @click="viewClient(props.item.company_id)"
              target="_self"
            >
              {{ showUploader(props.item) }}
            </a>
          </td>
          <td class="text-xs-left">
            {{ moment(props.item.created_at).fromNow() }}
          </td>
        </tr>
      </template>

      <template slot="no-data">
        <v-layout class="text-xs-center grey--text">
          <v-flex>
            <v-icon size="16" color="grey"> priority_high </v-icon>
            <span class="ml-1">None</span>
          </v-flex>
        </v-layout>
      </template>
    </v-data-table>
  </v-content>
</template>

<script>
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'DocumentTable',
  props: {
    documents: {
      type: Array,
    },
  },
  data() {
    return {
      moment,
      headers: [
        {
          text: 'Name (Click to open)',
          align: 'left',
          sortable: true,
          value: 'name',
          width: '40%',
        },
        {
          text: 'Entity (Click for dashboard)',
          align: 'left',
          sortable: true,
          value: 'company.name',
          width: '30%',
        },
        {
          text: 'Uploaded by',
          align: 'left',
          sortable: true,
          value: 'client_name',
          width: '20%',
        },
        {
          text: 'Uploaded at',
          align: 'left',
          value: 'created_at',
          sortable: true,
          width: '20%',
        },
      ],
    };
  },
  methods: {
    getNameAndUserOfCompany(company_id) {
      let company = this.companies.find(c => c.id === company_id);

      if (company) {
        if (company.entity_type === 'Individual') {
          return `${company.user.full_name}`;
        } else {
          return `${company.name} (${company.user.full_name})`;
        }
      }
      return 'Missing Name';
    },
    showUploader(activity) {
      return activity.description.split(' uploaded ')[0];
    },
    viewClient(companyId) {
      window.open(`/admin-dashboard?companyId=${companyId}`, '_blank');
    },
    openDocument(doc) {
      const path = `/${doc.source
        .split('/')
        .slice(3)
        .slice(0, -1)
        .join('/')}`;

      window.open(
        `/admin-documents?companyId=${doc.company_id}&path=${path}&previewName=${doc.name}`,
        '_blank',
      );
    },
  },
  computed: {
    ...mapState('companies', ['companies']),
  },
  watch: {},
};
</script>

<style lang="postcss" scoped></style>
